import React, { useContext, useState } from 'react';
import { convertDateFromApiToUserTimezone } from 'utils/utility_functions/timezone';
import ImageComponent from 'shared/ImageComponent';
import { paginationDropdownOptions } from 'utils/utils';
import { UserDetailsContext } from 'context/userDetailsContext';
import constants from 'constants/index';
import { Dropdown } from 'primereact/dropdown';
import { handlePageNumberInPagination } from 'common/pagination';
import { truncateText } from 'utils/utility_functions/textTruncate';
import { generateFullName } from 'utils/generateFullNameUtils';
import ResizableDataTable from 'components/ResizableDataTable/ResizableDataTable';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom';

function ActivityLogTable(props) {
  const { activityLog, isCaseSpecific, isLead, isFromDashBoard } = props;
  const history = useHistory();
  const userContext = useContext(UserDetailsContext);
  const [pageLimit, setPageLimit] = useState(getPageLimit() ?? 10);
  const emptyDataValue = '-';

  const dateTimeTemplate = (rowData) => {
    if (rowData && rowData.timestamp) {
      return (
        <>
          <span className="p-column-title text-break">Date and Time</span>
          <div className="d-block">
            <div
              title={`${convertDateFromApiToUserTimezone(
                rowData.timestamp,
                userContext?.userDetails?.timezone,
                constants.month_date_year_format
              )}`}
            >{`${convertDateFromApiToUserTimezone(
              rowData.timestamp,
              userContext?.userDetails?.timezone,
              constants.month_date_year_format
            )}`}</div>
            <div
              title={`${convertDateFromApiToUserTimezone(
                rowData.timestamp,
                userContext?.userDetails?.timezone,
                constants.hour_minute_12_format
              )}`}
            >
              {`${convertDateFromApiToUserTimezone(
                rowData.timestamp,
                userContext?.userDetails?.timezone,
                constants.hour_minute_12_format
              )}`}
            </div>
          </div>
        </>
      );
    } else {
      return 'N/A';
    }
  };

  const redirectUser = (data) => {
    if (data) {
      let route = '';

      //TODO:We need to add "cotact_type" key here. This will help us to distinguish between client and firm-user/firm-admin as the if condition is not meet the correct way . Add this key when it is added to BE .
      if (data?.items?.contact_id && !data?.items?.firm_user_id) {
        route = data?.items?.contact_id ? `/contacts/${data?.items?.contact_id}` : '/contacts';
      } else {
        route = data?.items?.firm_user_id ? `/settings/team-management/${data?.items?.firm_user_id}` : '/settings/team-management';
      }
      return route;
    }
  };

  const userTemplate = (rowData) => {
    const userId = rowData?.items?.firm_user_id || rowData?.items?.contact_id;
    return (
      <>
        <span className="p-column-title text-break">Users</span>
        {/* <span className="d-flex align-items-center"> */}
        {/* <Link
          className="d-flex align-items-center pointer text-decoration-none"
          to={() => redirectUser(rowData)}
          onClick={() => {
            if (rowData?.sk && rowData?.pk) handleSettingSkAndPkToLocalStorage(rowData?.sk, rowData?.pk);
          }}
        > */}
        <div className="d-flex align-items-center">
          <ImageComponent
            filePath={userId ? `${rowData?.items?.tenant_id}/${userId}/profile_image` : null}
            fileName={rowData?.items?.first_name}
            fileSize="small.jpg"
          />

          <span
            className="text-nowrap"
            title={generateFullName(rowData?.items) ? generateFullName(rowData?.items) : rowData?.items?.user_name || undefined}
          >
            {rowData?.items?.firm_user_id && <i className="fas fa-user-tie me-2"></i>}
            {generateFullName(rowData?.items)
              ? truncateText(generateFullName(rowData?.items), 15)
              : truncateText(rowData?.items?.user_name, 15) || 'N/A'}
          </span>
        </div>
        {/* </Link> */}
      </>
    );
  };

  const getContact = (rowData, contact) => {
    localStorage.setItem('sk', rowData?.sk);
    localStorage.setItem('pk', rowData?.pk);

    let url = '';
    let stateToPass = '';

    if (rowData?.type === 'Contact') {
      rowData?.items?.contact_id && (url = `/contacts/${rowData?.items?.contact_id}`);
      stateToPass = rowData;
    } else if (rowData?.type === 'Files') {
      if (rowData?.items?.file_id) {
        url = `/cases/${rowData?.items?.case_id}/files?file_id=${rowData?.items?.file_id}`;
      }
      stateToPass = rowData;
    } else if (rowData?.type === 'Lead' || rowData?.items?.is_lead === true) {
      url = `/leads/${rowData?.items?.case_id}`;
      stateToPass = rowData;
    }

    if (rowData?.type === 'Contact' && rowData?.items?.contact_id) {
      return (
        <Link to={url} state={stateToPass} className={'redirection-link-no-text-transform'} title={contact}>
          {' : ' + contact}
        </Link>
      );
    } else if (rowData?.type === 'Files' && rowData?.items?.entry_type !== 'folder') {
      return (
        <Link to={url} state={stateToPass} className={'redirection-link-no-text-transform'} title={contact}>
          {rowData?.items?.display_name ? ` : ${rowData?.items?.display_name}` : contact}
        </Link>
      );
    } else if (rowData?.type === 'Lead') {
      return (
        <Link to={url} state={stateToPass} className={'redirection-link-no-text-transform'} title={contact}>
          {contact}
        </Link>
      );
    } else {
      return <span>{contact ? ' : ' + contact : null}</span>;
    }
  };
  const changesTemplate = (rowData) => {
    if (!rowData?.message)
      return (
        <>
          <span className="p-column-title text-break">Description</span>
          <div className="ellipsis-text">N/A</div>
        </>
      );

    const { message: originalMessage, items } = rowData;
    let message = originalMessage;
    let contact = '';

    if ((items?.display_name && items?.file_id) || items?.contact_id) {
      const [firstPart, ...rest] = originalMessage.split(':');
      message = firstPart.replace(items.display_name, '').trim();
      contact = rest.join(':').trim();
    }

    const trimColon = (str) => (str?.endsWith?.(':') ? str?.slice(0, -1) : str);

    return (
      <>
        <span className="p-column-title text-break">Description</span>
        <div className="ellipsis-text" title={originalMessage}>
          {trimColon(message?.trim())?.endsWith?.(':') ? trimColon(message?.trim()).slice(0, -1) : trimColon(message?.trim())}
          {trimColon(getContact(rowData, contact))}
        </div>
      </>
    );
  };

  // const changesTemplate = (rowData) => {
  //   // console.log('rowData',rowData);
  //   let message = rowData?.message;
  //   let msg = [];
  //   console.log('msg',msg, rowData,msg?.[0]?.trim().replace(rowData?.items?.display_name) );
  //   if(rowData?.items?.display_name && rowData?.items?.file_id){
  //     msg = rowData?.message.split(':');
  //     message = msg?.[0]?.trim().replace(rowData?.items?.display_name,"")
  //   }
  //   const contactPart = msg?.[1]?.trim();
  //   console.log('message', message?.trim().endsWith?.(':') ? message.slice(0, -1) : message);
  //   return (
  //     <div className="d-flex flex-wrap">
  //       <span className="p-column-title text-break">Description</span>
  //       <div className="ellipsis-text" title={rowData?.message ? rowData?.message : undefined}>
  //         {/* {rowData?.message ? <>{rowData?.message}</> : 'N/A'} */}
  //         {rowData?.message ? (
  //           <>
  //               {message?.trim().endsWith?.(':') ? message.slice(0, -1) : message} {getContact(rowData, contactPart)}
  //         ) : (
  //           'N/A'
  //         )}
  //       </div>
  //     </div>
  //   );
  // };
  const caseLeadTemplate = (rowData) => {
    localStorage.setItem('sk', rowData?.sk);
    localStorage.setItem('pk', rowData?.pk);

    let url = '';
    let stateToPass = '';
    const caseId = rowData?.items?.case_id;

    //TODO:We need to add "is_lead"/"event_type" key to distinguish between lead and case moudle . Add this key when it is available from BE

    // Handle older data cases based on `type` and `is_lead`
    if ((rowData?.type?.toLowerCase() === 'lead' || rowData?.items?.is_lead === true) && caseId) {
      // Redirect to lead if type is 'lead' or `is_lead` is true and `case_id` exists
      url = `/leads/${caseId}`;
      stateToPass = rowData;
    } else if ((rowData?.type?.toLowerCase() === 'case' || rowData?.items?.is_lead === false || rowData?.is_lead === undefined) && caseId) {
      // Redirect to case if type is 'case' or `is_lead` is false or not present and `case_id` exists
      url = `/cases/${caseId}`;
      stateToPass = rowData;
    } else if (rowData?.items?.is_lead === true && !caseId) {
      // Redirect to lead if `is_lead` is true but no `case_id` exists
      url = '/leads';
      stateToPass = rowData;
    } else if (rowData?.items?.is_lead === false && !caseId) {
      // Redirect to case if `is_lead` is false or not present and no `case_id` exists
      url = '/cases';
      stateToPass = rowData;
    }

    const isRediretionLink = Boolean(rowData?.items?.case_name);

    return isRediretionLink ? (
      <div className="activity-log-ellipsis-text">
        <Link
          to={() => {
            if (rowData?.items?.case_name) {
              return url;
            }
          }}
          state={stateToPass}
          className={'redirection-link-no-text-transform text-decoration-none'}
          title={rowData?.items?.case_name ? rowData?.items?.case_name : undefined}
        >
          {rowData?.items?.case_name ? rowData?.items?.case_name : 'N/A'}
        </Link>
      </div>
    ) : (
      emptyDataValue
    );
  };

  function getPageLimit() {
    if (isLead && userContext && isCaseSpecific) {
      return userContext?.firmDetails?.pagination_preference?.leads?.activity_log;
    } else if (isCaseSpecific && userContext && !isLead) {
      return userContext?.firmDetails?.pagination_preference?.case?.activity_log;
    } else if (isFromDashBoard && userContext) {
      return userContext?.firmDetails?.pagination_preference?.dashboard?.activity_log;
    }
  }

  function getFilePathForPagination() {
    if (isLead && userContext && isCaseSpecific) {
      return { module: 'leads', subModule: '', listName: 'activity_log' };
    } else if (isCaseSpecific && userContext && !isLead) {
      return { module: 'case', subModule: '', listName: 'activity_log' };
    } else if (isFromDashBoard) {
      return { module: 'dashboard', subModule: '', listName: 'activity_log' };
    } else {
      return { module: 'report', subModule: '', listName: 'activity_log' };
    }
  }

  function pageOnChange(event) {
    let path = getFilePathForPagination();
    setPageLimit(event.value);
    handlePageNumberInPagination(userContext, path?.module, path?.subModule, path?.listName, event.value);
  }

  const paginatorTemplate = {
    layout: 'RowsPerPageDropdown PrevPageLink NextPageLink',
    RowsPerPageDropdown: (options) => {
      return (
        <>
          <span className="mx-1" style={{ color: 'var(--black-500)', userSelect: 'none' }}>
            Item Per Page
          </span>
          <Dropdown value={options.value} options={paginationDropdownOptions} onChange={pageOnChange} />
        </>
      );
    },
  };

  return (
    <div className="datatable-responsive overflow-auto">
      <ResizableDataTable
        value={activityLog}
        responsiveLayout="scroll"
        className="p-datatable-responsive"
        emptyMessage="No Data Found."
        paginatorTemplate={paginatorTemplate}
        rows={pageLimit}
        stripedRows
        paginator
        rowsPerPageOptions={[10, 20, 50, 100]}
        sortField="timestamp"
        sortOrder={-1}
        columns={[
          {
            field: 'timestamp',
            header: 'Date And Time',
            body: dateTimeTemplate,
            sortable: true,
            responsiveLayout: 'scroll',
            bodyClassName: 'ellipsis-text',
          },
          { field: 'message', header: 'Description', body: changesTemplate, sortable: true, bodyClassName: 'ellipsis-text' },
          {
            field: 'items.case_name',
            header: 'Case/Lead Name',
            body: caseLeadTemplate,
            bodyClassName: 'ellipsis-text',
            hidden: isCaseSpecific,
          },
          { field: 'items.user_name', header: 'Users', body: userTemplate, sortable: true, bodyClassName: 'ellipsis-text' },
        ].filter((val) => val)}
        storageKey="activity_log_table_column_widths"
      />
    </div>
  );
}

export default ActivityLogTable;
